import Vue from 'vue'
import Router from 'vue-router'
//避免到当前位置的冗余导航,造成的报错
const originalPush = Router.prototype.push
 
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const Strategy = () => import('@/views/Strategy')
const text = () => import('@/views/text')
const Index = () => import('@/views/Index')
const Login = () => import('@/views/Login')
const DownOrder = () => import('@/views/DownOrder')
const Reg = () => import('@/views/Reg')
const My = () => import('@/views/My')
const Quotation = () => import('@/views/Quotation')
const Assets = () => import('@/views/Assets')
const Empty = () => import('@/views/Empty')
const Language = () => import('@/views/Language')
const Aboutus = () => import('@/views/Aboutus')
const AboutuDetail = () => import('@/views/AboutuDetail')
const Faq = () => import('@/views/Faq')
const Friends = () => import('@/views/Friends')

//首页
const Goods = () => import('@/views/index/Goods')
const Futures = () => import('@/views/index/Futures')
const Maintenance = () => import('@/views/index/Maintenance')
const Shenggou = () => import('@/views/index/Shenggou')
const Wakuang = () => import('@/views/index/Wakuang')
const MyWakuang = () => import('@/views/index/MyWakuang')
const MyShenggou = () => import('@/views/index/MyShenggou')
const WakuangInfo = () => import('@/views/index/WakuangInfo')
const ShenggouInfo = () => import('@/views/index/ShenggouInfo')
const About = () => import('@/views/index/About')

//我的
const Setting = () => import('@/views/mine/Setting')
const DepositRecord = () => import('@/views/mine/DepositRecord')
const WithdrawalRecord = () => import('@/views/mine/WithdrawalRecord')
const Message = () => import('@/views/mine/Message')
const Team = () => import('@/views/mine/Team')
const Invite = () => import('@/views/mine/Invite')
const Deposited = () => import('@/views/mine/Deposited')
const DepositDetail = () => import('@/views/mine/DepositDetail')
const Withdrawal = () => import('@/views/mine/Withdrawal')
const Payment = () => import('@/views/mine/Payment')
const AddBankCard = () => import('@/views/mine/AddBankCard')
const AddCryptocurrency = () => import('@/views/mine/AddCryptocurrency')
const TeamInfo = () => import('@/views/mine/TeamInfo')
const ChangePass = () => import('@/views/mine/ChangePass')
const ZbRecord = () => import('@/views/mine/ZbRecord')
const Reset = () => import('@/views/Reset')

const Order = () => import('@/views/mine/Order')
const OrderAi = () => import('@/views/mine/OrderAi')
const OptionOrder = () => import('@/views/mine/OptionOrder')
const FuturesOrder = () => import('@/views/mine/FuturesOrder')
const Record = () => import('@/views/mine/Record')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/Strategy',
      name: 'Strategy',
      component: Strategy
    },
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/text',
      name: 'text',
      component: text
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Reg',
      name: 'Reg',
      component: Reg
    },
    {
      path: '/My',
      name: 'My',
      component: My
    },
    {
      path: '/DownOrder',
      name: 'DownOrder',
      component: DownOrder
    },
    {
      path: '/Setting',
      name: 'Setting',
      component: Setting
    },
    {
      path: '/DepositRecord',
      name: 'DepositRecord',
      component: DepositRecord
    },
    {
      path: '/WithdrawalRecord',
      name: 'WithdrawalRecord',
      component: WithdrawalRecord
    },
    {
      path: '/Message',
      name: 'Message',
      component: Message
    },
    {
      path: '/Team',
      name: 'Team',
      component: Team
    },
    {
      path: '/Invite',
      name: 'Invite',
      component: Invite
    },
    {
      path: '/Deposited',
      name: 'Deposited',
      component: Deposited
    },
    {
      path: '/DepositDetail',
      name: 'DepositDetail',
      component: DepositDetail
    },
    {
      path: '/Withdrawal',
      name: 'Withdrawal',
      component: Withdrawal
    },
    {
      path: '/Quotation',
      name: 'Quotation',
      component: Quotation
    },
    {
      path: '/Goods',
      name: 'Goods',
      component: Goods
    },
    {
      path: '/Futures',
      name: 'Futures',
      component: Futures
    },
    {
      path: '/Assets',
      name: 'Assets',
      component: Assets
    },
    {
      path: '/Payment',
      name: 'Payment',
      component: Payment
    },
    {
      path: '/Maintenance',
      name: 'Maintenance',
      component: Maintenance
    },
    {
      path: '/AddBankCard',
      name: 'AddBankCard',
      component: AddBankCard
    },
    {
      path: '/AddCryptocurrency',
      name: 'AddCryptocurrency',
      component: AddCryptocurrency
    },
    {
      path: '/Shenggou',
      name: 'Shenggou',
      component: Shenggou
    },
    {
      path: '/Wakuang',
      name: 'Wakuang',
      component: Wakuang
    },
    {
      path: '/MyWakuang',
      name: 'MyWakuang',
      component: MyWakuang
    },
    {
      path: '/WakuangInfo',
      name: 'WakuangInfo',
      component: WakuangInfo
    },
    {
      path: '/ShenggouInfo',
      name: 'ShenggouInfo',
      component: ShenggouInfo
    },
    {
      path: '/MyShenggou',
      name: 'MyShenggou',
      component: MyShenggou
    },
    {
      path: '/Order',
      name: 'Order',
      component: Order
    },
    {
      path: '/OrderAi',
      name: 'OrderAi',
      component: OrderAi
    },
    {
      path: '/Record',
      name: 'Record',
      component: Record
    },
    {
      path: '/Empty',
      name: 'Empty',
      component: Empty
    },
    {
      path: '/Language',
      name: 'Language',
      component: Language
    },
    {
      path: '/Faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/Aboutus',
      name: 'Aboutus',
      component: Aboutus
    },
    {
      path: '/AboutuDetail',
      name: 'AboutuDetail',
      component: AboutuDetail
    },
    {
      path: '/Friends',
      name: 'Friends',
      component: Friends
    },
    {
      path: '/OptionOrder',
      name: 'OptionOrder',
      component: OptionOrder
    },
    {
      path: '/FuturesOrder',
      name: 'FuturesOrder',
      component: FuturesOrder
    },
    {
      path: '/TeamInfo',
      name: 'TeamInfo',
      component: TeamInfo
    },
    {
      path: '/ChangePass',
      name: 'ChangePass',
      component: ChangePass
    },
    {
      path: '/ZbRecord',
      name: 'ZbRecord',
      component: ZbRecord
    },
    {
      path: '/About',
      name: 'About',
      component: About
    },
    {
      path: '/Reset',
      name: 'Reset',
      component: Reset
    }
  ]
})

// 路由守卫   处理token
import router from './router'
import token_before from './router_token_before'
router.beforeEach((to, from,next) => {
  token_before(to,from,next)
});

